import get from 'lodash/get';
import { selectPreferences } from '../selectors';
import { getDefaultLayout } from './defaultLayouts';
import { selectCurrentWorkspace, selectCurrentUser } from 'store/Faraday/selectors';

/**
 * Return the row-based layout for a given dashboard type.
 * Falls back to the default layout if no saved preferences exist or the format is unrecognized.
 *
 * @param {Object} state - Redux state
 * @param {string} type - Dashboard type (CONTINUOUS_SCANNING | PENTEST | GENERAL)
 * @returns {Array<Array>} - Row-based layout (array of arrays of widget configs)
 */
const selectDashboardLayout = (state, type) => {
  const preferences = selectPreferences(state);
  const savedLayout = get(preferences, `dashboard.${type}.widgets`, null);

  if (savedLayout && Array.isArray(savedLayout) && Array.isArray(savedLayout[0])) {
    return savedLayout;
  }

  return getDefaultLayout(type);
};

/**
 * Return the custom filter for a specific widget in the current workspace and user context.
 * Returns null if no filter is set.
 *
 * @param {Object} state - Redux state
 * @param {string} widgetId - Widget identifier (e.g. 'bySeverity', 'generalLatestFindings')
 * @returns {Object|null} - Filter object or null
 */
export const selectCustomFilter = (state, widgetId) => {
  const preferences = selectPreferences(state);
  const workspace = selectCurrentWorkspace(state);
  const user = selectCurrentUser(state);

  if (!workspace || !user) return null;

  const workspaceId = workspace;
  const userId = user.id;

  return get(preferences, ['dashboard', 'customFilters', workspaceId, userId, widgetId], null);
};

export default selectDashboardLayout;
